import React, { forwardRef, useState, useEffect } from "react";
import firebase from "../../config/Firebase";
import { useData } from "../../context/DataContext";
import { Link } from "react-router-dom";
import MaterialTable from "material-table";
import { useAuth } from "../../context/AuthContext";
import { Button, ButtonGroup } from "@material-ui/core";
import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import AddBox from "@material-ui/icons/AddBox";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";

import NumberFormat from "react-number-format";
import { db } from "../../config/Firebase";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const DpTable = () => {
  const { tables: rows, ...data } = useData();
  const [filteredData, setData] = useState(null);
  const [rangeValue, setRange] = useState(null);
  const [rowData, setRow] = useState(null);
  const [date, setDate] = useState(null);

  useEffect(() => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();

    today = yyyy + "-" + mm + "-" + dd;
    setDate(today);
  }, []);

  useEffect(() => {
    if (date !== null) {
      db.collection("dptable")
        .doc(date)
        .get()
        .then((querySnapshot) => {
          if (querySnapshot.data() === undefined) {
            setRow([]);
          } else {
            setRow(querySnapshot.data().data);
          }
        });
    }
  }, [date]);

  // useEffect(() => {
  //   setData(rows);
  // }, [rows]);

  const { activeUser } = useAuth();
  const columns = [
    {
      cellStyle: { width: 120, padding: "10px 15px", fontSize: 12 },
      field: "ticker",
      title: "Ticker",
      render: (params) => <Link to={{ pathname: `/dphis/${params.ticker}` }}>{params.ticker}</Link>
    },
    {
      cellStyle: { width: 120, padding: "10px 15px", fontSize: 12 },
      field: "tape",
      title: "Type",
    },
    {
      cellStyle: { width: 120, padding: "10px 15px", fontSize: 12 },
      defaultSort: "desc",
      field: "time",
      title: "Time",
      // render: (params) => (
      //   <Moment fromNow>
      //     {moment.tz(params.time, "YYYY-MM-DD hh:mm:ss", "America/New_York")}
      //   </Moment>
      // ),
      type: `datetime`,
    },

    {
      cellStyle: { width: 120, padding: "10px 15px", fontSize: 12 },
      field: "price",
      title: "Price",
    },
    

    {
      cellStyle: { width: 120, padding: "10px 15px", fontSize: 12 },
      field: "sentiment",
      title: "Sentiment",
    },
    {
      cellStyle: {
        width: 120,
        padding: "5px 15px",
        fontSize: 12,
        color: "#E9626C",
        fontWeight: 700,
      },
      headerStyle: {
        color: "#E9626C",
        fontWeight: 700,
      },
      field: "premium",
      title: "Premium",
      render: (params) => (
        <NumberFormat
          value={params.premium}
          displayType={"text"}
          thousandSeparator={true}
          prefix={"$ "}
        >
        </NumberFormat>
      ),
    },
    {
      cellStyle: { width: 120, padding: "10px 15px", fontSize: 12 },
      field: "size",
      title: "Size",
      render: (params) => (
        <NumberFormat
          value={params.size}
          displayType={"text"}
          thousandSeparator={true}
        >
        </NumberFormat>
      ),
    },
    {
      cellStyle: { width: 120, padding: "10px 15px", fontSize: 12 },
      field: "exchange",
      title: "Exchange",
    },
  ].filter((el) => el);

  // console.log(rowData);

  return (
    <div className="bg-light-2 pt-5 mt-5" style={{ fontSize: `0.8rem` }}>
      <section className="pt-5 pb-5">
        <div className="container-fluid mb-5">
          {/* <h1 className="font-weight-bold my-3 py-3">Unusual Option Activity Tracker</h1> */}
          <div className="shadow border p-4 rounded-xl mx-xl-3 bg-white">
            <div className="mb-4">
              {/* <h6 className='font-weight-bold mb-3'>
                Filter By premium amount
              </h6> */}
              <div className="d-flex flex-column flex-md-row align-items-center justify-content-between">
                {/* <RangeSlider setRange={setRange} type='real' /> */}
                <div className="ml-md-auto mb-4 mb-md-0 mr-md-4">
                  <input
                    className="form-control"
                    type="date"
                    name="data"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                  />
                </div>
              </div>
              {rowData === null ? (
                <>Loading... </>
              ) : (
                <MaterialTable
                  style={{ border: 0, boxShadow: "unset" }}
                  title=""
                  options={{
                    // filtering: true,
                    pageSize: 20,
                    pageSizeOptions: [20, 50, 100],
                    headerStyle: {
                      padding: "5px 15px",
                      // textAlign: 'center',
                      backgroundColor: "#847DF9",
                      color: "#FFF",
                    },
                    rowStyle: (x, index) => {
                      if (index % 2) {
                        return { backgroundColor: "#D9E2F3" };
                      }
                    },
                  }}
                  data={rowData}
                  icons={tableIcons}
                  columns={columns}
                />
              )}
            </div>
            
          </div>
        </div>
      </section>
    </div>
  );
};

export default DpTable;
